import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

const SurveyListPage = lazyWithRetry(() =>
  import("@/features/survey/pages/SurveyListPage").then((m) => ({ default: m.SurveyListPage })));
const SurveyDetailPage = lazyWithRetry(() =>
  import("@/features/survey/pages/SurveyDetailPage").then((m) => ({ default: m.SurveyDetailPage })));
const SurveyResultsPage = lazyWithRetry(() =>
  import("@/features/survey/pages/SurveyResultsPage").then((m) => ({ default: m.SurveyResultsPage })));

export const SURVEY_PATH = "/enquetes";
export const SURVEY_DETAIL_PATH = "/enquetes/:id";
export const SURVEY_RESULTS_PATH = "/enquetes/:id/resultats";

export const getSurveyDetailPath = (id: string): string => `${SURVEY_PATH}/${id}`;
export const getSurveyResultsPath = (id: string): string => `${SURVEY_PATH}/${id}/resultats`;

const surveyRoutes: RouteConfig[] = [
  {
    path: SURVEY_PATH,
    element: <SurveyListPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: SURVEY_DETAIL_PATH,
    element: <SurveyDetailPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: SURVEY_RESULTS_PATH,
    element: <SurveyResultsPage />,
    isProtected: true,
    useMainLayout: true,
  },
];

export default surveyRoutes;
